// @ts-ignore
export default function PageHeader(
  {title, children}: {title: string; children?: React.ReactNode} = {title: 'Please Add a Title'},
) {
  
  return (
    <div className="page-header">
      <div className="container flex justify-between items-center">
        <div className="title">{title}</div>
          {children}
      </div>
    </div>
  );
}